// Admin Onboarding Step IDs
export const ADMIN_STEP_IDS = {
  WELCOME: 'welcome',
  COMPANY_TOPICS: 'company-topics',
  LECTURE_INFO: 'lecture-info',
  TERMS: 'terms'
};

// Admin Onboarding Step Configuration
export const ADMIN_ONBOARDING_STEPS = [
  {
    id: ADMIN_STEP_IDS.WELCOME,
    title: 'Willkommen',
    description: 'Einführung ins Administrator-Onboarding',
    expandable: false,
    expanded: false,
    complete: false,
    active: false,
    neutralDisplay: false
  },
  {
    id: ADMIN_STEP_IDS.COMPANY_TOPICS,
    title: 'Themenbereiche zuordnen',
    description: 'Firma neuen Themenbereichen zuordnen und Kompetenzen angeben',
    expandable: false,
    expanded: false,
    complete: false,
    active: false,
    neutralDisplay: false
  },
  {
    id: ADMIN_STEP_IDS.LECTURE_INFO,
    title: 'Vorträge einreichen',
    description: 'Informationen über neue Vorträge lesen',
    expandable: false,
    expanded: false,
    complete: false,
    active: false,
    neutralDisplay: false
  },
  {
    id: ADMIN_STEP_IDS.TERMS,
    title: 'Nutzungsbedingungen',
    description: 'Nutzungsbedingungen zustimmen',
    expandable: false,
    expanded: false,
    complete: false,
    active: false,
    neutralDisplay: false,
    isLast: true
  }
];

// Form validation states
export const VALIDATION_STATES = {
  VALID: 'valid',
  INVALID: 'invalid',
  PENDING: 'pending'
};